.wrapper {
  position: relative;
  display: inline-flex;
}

.badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 16px;
  height: 16px;
  border-radius: var(--tuna-shape-radius-md);
  background-color: var(--tuna-palette-secondary-main);
  color: var(--tuna-palette-secondary-contrastText);
  font-size: var(--tuna-typography-fontSize-2xs);
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  line-height: 1;
}
